import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2d3eddf5")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: "alignment-line",
    style: { left: _ctx.left, top: _ctx.top }
  }, [
    _createVNode("div", {
      class: ['line', _ctx.type],
      style: _ctx.sizeStyle
    }, null, 6)
  ], 4))
})